/**
 * Lowercases and strips diacritics so accent-free queries (e.g. "nao", "cafe")
 * still match accented pt-BR text. Shared by search/filter surfaces.
 */
export function foldAccents(text: string): string {
  return text.normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase();
}
